export enum MovementStatus {
    AWAITING_PREPARATION = 'AWAITING_PREPARATION',
	PREPARED = 'PREPARED',
    STARTED = 'STARTED',
    FINISHED = 'FINISHED',
    CANCELED = 'CANCELED'
}
